import { useApi } from "../api";
import { createAdminCrudApi } from "../createAdminCrudApi";
import { DECK_ADMIN_URL } from "./deckAdminUrl";
import { SearchSubstructureMaterialsResponse, UpdateSubstructureMaterialBody } from "./types/substructureMaterials";

export const useDeckSubstructureMaterialsApi = () => {
  const crud = createAdminCrudApi<SearchSubstructureMaterialsResponse, never, UpdateSubstructureMaterialBody>(
    useApi(),
    DECK_ADMIN_URL,
    "substructure_materials",
  );

  return {
    useDeckSubstructureMaterials: crud.useSearch,
    getDeckSubstructureMaterials: crud.search,
    updateDeckSubstructureMaterial: crud.update,
    generateUploadImageUrl: crud.generateUploadImageUrl,
    uploadImage: crud.uploadImage,
  };
};

export default useDeckSubstructureMaterialsApi;
